<template>
  <v-card align="center" justify="center" light min-width="20vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <v-icon class="mb-7" color="primary" size="70">fa-sync-alt</v-icon>
      <p v-html="$t('message')"/>
      <v-btn class="mt-2" @click="changeToken">{{ $t('btnChange') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/auth';
import { mapMutations } from 'vuex';
export default {
  name: "ChangeToken",
  methods: {
    ...mapMutations(['setAutomationToken']),
    changeToken() {
      Repository.changeAutomationToken().then((response) => {
        if(response.status < 400 && response.data !== null) {
          alert(`Automation token was successfully changed!\nThe new automation token is: ${response.data}`);
          this.setAutomationToken(response.data);
          this.close();
        }
        else
          alert('An error occurred.');
      });
    },
    close() {
      this.$emit('closeWindow');
    }
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Change Automation Token",
    "message": "You can <strong>change the Automation Token</strong> for security reasons.<br>If you change the token, all automated scripts will get out of sync with Swiset.",
    "btnChange": "Yes, change token"
  },
  "es": {
    "title": "Cambiar Automation Token",
    "message": "Puedes <strong>cambiar el Automation Token</strong> por razones de seguridad.<br>Si cambias el token, todos los scripts automatizados quedarán desincronizados de Swiset.",
    "btnChange": "Sí, cambiar token"
  }
}
</i18n>

<style scoped>

</style>
